// extracted by mini-css-extract-plugin
export default {"head":"Topics_head__Gnf4q","stage":"Topics_stage__-ZMY1","title":"Topics_title__TwnaO","wrapper":"Topics_wrapper__ybmch"};